/**
 * @file The document store singleton on `parameters/analyticsLabels`, the
 * name the UI shows for each analytics scope level. Consumers:
 * `useAnalyticsScopeLabels` and the Settings → Analytics Scope labels section.
 * The analytics service never reads this document, so writing it through the
 * store's `setMerge`, which adds `modifiedAt`, is safe.
 */
import { ANALYTICS_SCOPE_LABELS_PATH, type AnalyticsScopeLabels } from '#types';
import { createDocumentStore } from '@/store';

export const analyticsScopeLabelsStore = createDocumentStore<
  Partial<AnalyticsScopeLabels>
>(ANALYTICS_SCOPE_LABELS_PATH);
